import React from 'react';
import { MVX_REFERENCES } from '../../models/mvxReferences';

/**
 * MVX "References" tab — the literature. MVX isn't a Section, so it can't use
 * the DB Reference Library; the citations are the static `MVX_REFERENCES`
 * module and render exactly as the house References tab does: a
 * `consideration-title` per group, then a `<ul>` whose items read
 * "<citation>  —  <identifier>".
 *
 * Order is explicit rather than inferred: the test-level citations first, then
 * the per-marker ones.
 *
 * RANGE PROVENANCE used to sit in the middle of this list and now has a tab of
 * its own — see MvxRangeReferencesSection for why.
 */
export class MvxReferencesSection extends React.Component {
  renderGroup(group: typeof MVX_REFERENCES[0], key: string) {
    return (
      <span key={key}>
        <span className="consideration-title">{group.title}</span>
        <ul>
          {group.references.map((r, i) => (
            <li key={i}>
              {r.citation}
              {r.url && (
                <>
                  {'  —  '}
                  <a href={r.url} target="_blank" rel="noopener noreferrer">
                    {r.identifier ?? r.url}
                  </a>
                </>
              )}
            </li>
          ))}
        </ul>
      </span>
    );
  }

  render() {
    const isMarker = (g: typeof MVX_REFERENCES[0]) => g.title.startsWith('Marker References');
    return (
      <span>
        {MVX_REFERENCES.filter(g => !isMarker(g)).map((g, i) => this.renderGroup(g, `test-${i}`))}
        {MVX_REFERENCES.filter(isMarker).map((g, i) => this.renderGroup(g, `marker-${i}`))}
      </span>
    );
  }
}

export default MvxReferencesSection;
